export interface AboeloAppLink {
  label: string;
  href: string;
  current?: boolean;
}

/**
 * App paths are served without a trailing slash and are linked that way.
 * WordPress pages (ueber-uns, impressum, senioren-rechner, …) are the
 * opposite: they 301 from the slash-free form, so their slash stays.
 */
export const ABOELO_APPS: AboeloAppLink[] = [
  { label: 'aboelo.de', href: 'https://aboelo.de/' },
  { label: 'Digital', href: 'https://aboelo.de/digital' },
  { label: 'Quiz', href: 'https://aboelo.de/quiz' },
  { label: 'Fitness', href: 'https://aboelo.de/fitness', current: true },
  { label: 'Sudoku', href: 'https://aboelo.de/sudoku/' },
  { label: 'Post', href: 'https://aboelo.de/post/' },
  { label: 'Senioren-Rechner', href: 'https://aboelo.de/#rechner' },
  { label: 'Hilfsmittel finden', href: 'https://aboelo.de/hilfsmittel' },
];

export const ABOELO_LEGAL_LINKS = [
  { label: 'Über aboelo', href: 'https://aboelo.de/ueber-uns/' },
  { label: 'Impressum', href: 'https://aboelo.de/impressum/' },
  { label: 'Datenschutzerklärung', href: 'https://aboelo.de/datenschutzerklaerung/' },
] as const;

export const ABOELO_ORGANIZATION_JSON_LD = {
  '@type': 'Organization',
  name: 'aboelo',
  url: 'https://aboelo.de/',
  logo: 'https://aboelo.de/fitness/aboeloLogo.png',
  // /sudoku is omitted: the URL currently answers with 404.
  sameAs: [
    'https://aboelo.de/',
    'https://aboelo.de/hilfsmittel',
    'https://aboelo.de/digital',
    'https://aboelo.de/quiz',
    'https://aboelo.de/fitness',
    'https://aboelo.de/post',
  ],
};

export const ABOELO_FITNESS_META = {
  title: 'aboelo Fitness – Übungen für Senioren',
  description:
    'Über 60 Übungen für Senioren mit Videoanleitungen – sitzend oder stehend, mit oder ohne Theraband. Kostenlos starten und täglich aktiv bleiben.',
  canonical: 'https://aboelo.de/fitness',
};
